import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { useQuery } from '@tanstack/react-query'
import { useNotification } from '../../../context/NotificationManager/NotificationManager'
import { getCentrosEstudio } from '../../../utils/api/centroEstudios'
import css from './CentroEstudiosSelector.module.css'

const CentroEstudiosSelector = ({
  className,
  multiple = false,
  name,
  label,
  value,
  onChange
}) => {
  const notification = useNotification()

  const { isLoading, data: centroList = [] } = useQuery({
    queryKey: ['centro_estudios', 'list'],
    queryFn: () =>
      getCentrosEstudio()
        .then(datos =>
          datos.sort((a1, a2) => a1.nombre.localeCompare(a2.nombre))
        )
        .catch(err => {
          notification.error({
            title: 'Error al recuperar los centros de estudio',
            content: err
          })
          return []
        })
  })

  return (
    <Autocomplete
      id={name}
      className={`${className} ${css.main}`}
      multiple={multiple}
      options={centroList}
      getOptionLabel={option => option.nombre || ''}
      loading={isLoading}
      loadingText='Cargando centros de estudio...'
      noOptionsText='No hay centros de estudio'
      value={value}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={onChange}
      renderInput={params => (
        <TextField {...params} label={label} variant='standard' />
      )}
    />
  )
}

export default CentroEstudiosSelector
